angular.module('gym.contacts').controller('EditMembershipExpirationCtrl', ["$scope", "$state", "flash", "contact", "membership", function($scope, $state, flash, contact, membership) {
  $scope.contact = contact;
  $scope.membership = membership;
  $scope.data = {
    expiration_date: membership.expiration_date,
    rootObjectName: 'membership'
  };
  $scope.save = function() {
    $scope.isLoading = true;
    $scope.data.errors = {};
    return contact.one('memberships', membership.id).doPUT($scope.data, 'update_expiration').then(function() {
      flash.success = "Updated successfully";
      return $scope.goToContact();
    }, function(response) {
      $scope.isLoading = false;
      $scope.data.errors = response.data.errors || response.data;
      return flash.error = response.data.error_message;
    });
  };
  return $scope.goToContact = function() {
    return $state.go('gym.contacts.edit', {
      contactType: `${contact.type}s`,
      contactId: contact.id
    });
  };
}]);
